import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipProblemaServiciiComponent } from './tip-problema-servicii.component';
import { AddTipProblemaServiciiComponent } from './add-tip-problema-servicii/add-tip-problema-servicii.component';
import { EditTipProblemaServiciiComponent } from './edit-tip-problema-servicii/edit-tip-problema-servicii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        TipProblemaServiciiComponent,
        AddTipProblemaServiciiComponent,
        EditTipProblemaServiciiComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TipProblemaServiciiComponent]
})
export class TipProblemaServiciiModule { }
